const locale = require('./chatMembers.i18n.json');

/*@ngInject*/
const ChatMembersController = function ($element, currentUserModel) {
    this.i18n = locale;
    this.isOpen = false;

    this.$onInit = function () {
        $element.addClass('chatMembers');
        this.currentUserId = currentUserModel.getCurrentUser().userId;
    };

    this.getChatMemberButtonTooltip = function () {
        if (this.hasInvitePermission) {
            return this.i18n.chatMembers.viewInviteChatMembersButtonTooltip;
        }

        return this.i18n.chatMembers.viewChatMembersButtonTooltip;
    };

    this.areAnyMembersAvailable = function () {
        let numberOfAvailableMembers = 0;
        if (!_.isNil(this.chatMembers)) {
            _.each(this.chatMembers, (chatMember) => {
                if (chatMember.availableToChat && chatMember.id !== this.currentUserId) {
                    numberOfAvailableMembers++;
                }
            });
        }

        return numberOfAvailableMembers > 0;
    };

    this.onChatMembersButtonClick = function () {
        this.isOpen = !this.isOpen;
    };
};

angular.module('gw-um-submission')
    .controller('chatMembersController', ChatMembersController);

